module.exports = __webpack_public_path__ + "profil.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/profil.svg
// module id = 121
// module chunks = 0